var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"title":(_vm.teatro.hash != 'UHmERrsRV19JCGQMg7Is' ? 'Experiencias' : 'FAN ZONE') + ' para la temporada ' + _vm.lista_abonados.nombre}}),_c('FirstBanner'),(_vm.events.length > 0)?_c('ListadoEventosImagen',{attrs:{"eventos":_vm.events}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }